// /**
//  * cart-drawer.js
//  * Include in theme.liquid:
//  *   <script src="{{ 'cart-drawer.js' | asset_url }}" defer></script>
//  *
//  * IMPORTANT: Your header cart icon link must have a `data-cart-toggle`
//  * attribute so this script only intercepts that exact element, e.g.:
//  *   <a href="{{ routes.cart_url }}" class="icon-box cart-box" data-cart-toggle>
//  *
//  * ─── STEAL DEALS SETUP ───────────────────────────────────────────
//  * 1. In Shopify Admin → Products → Collections → Create collection
//  *    Handle must be: steal-deals  (or change STEAL_DEAL_COLLECTION below)
//  * 2. Add any products you want shown as upsells to that collection
//  * 3. Set compare-at prices on those products to show the % badge
//  *
//  * ─── DISCOUNT CODES SETUP ────────────────────────────────────────
//  * In Shopify Admin → Discounts → Create discount code for each tier:
//  *   BUY2GET5   → 5% off  (min 2 items)
//  *   BUY3GET10  → 10% off (min 3 items)
//  *   BUY4GET15  → 15% off (min 4 items)
//  * Or change the code strings in the TIER_DISCOUNTS config below.
//  */

// (function () {
//   'use strict';

//   /* ═══════════════════════════════════════════════════════════════
//      CONFIG — driven by window.__cartDrawerConfig injected by
//      snippets/cart-drawer.liquid from theme settings.
//      Merchants change everything in Shopify Customizer →
//      Theme Settings → Cart Drawer. No JS edits needed.
//   ═══════════════════════════════════════════════════════════════ */
//   const _cfg = window.__cartDrawerConfig || {};

//   // Collection handle selected in Shopify Customizer
//   const STEAL_DEAL_COLLECTION = _cfg.stealDealHandle || '';
//   const STEAL_DEAL_LIMIT      = 6;

//   // Tier discounts — percentages, codes and min-qty from theme settings
//   const TIER_DISCOUNTS = _cfg.tierDiscounts || [
//     { minItems: 4, discount: 15, label: 'Flat 15% Off', code: 'BUY4GET15', tier: 4 },
//     { minItems: 3, discount: 10, label: 'Flat 10% Off', code: 'BUY3GET10', tier: 3 },
//     { minItems: 2, discount: 5,  label: 'Flat 5% Off',  code: 'BUY2GET5',  tier: 2 },
//   ];

//   /* ═══════════════════════════════════════════════════════════════
//      DOM REFS
//   ═══════════════════════════════════════════════════════════════ */
//   const drawer           = document.getElementById('cart-drawer');
//   const overlay          = document.getElementById('cart-drawer-overlay');
//   const closeBtn         = document.getElementById('cart-drawer-close');
//   const itemsContainer   = document.getElementById('cart-drawer-items');
//   const emptyState       = document.getElementById('cart-drawer-empty');
//   const footer           = document.getElementById('cart-drawer-footer');
//   const subtotalEl       = document.getElementById('cart-subtotal-value');
//   const stealDealsWrap   = document.getElementById('cart-steal-deals');
//   const stealOfferBar    = document.getElementById('cart-steal-offer-bar');
//   const stealOfferText   = document.getElementById('cart-steal-offer-text');
//   const stealApplyBtn    = document.getElementById('cart-steal-apply-btn');
//   const stealProducts    = document.getElementById('cart-steal-products');
//   const continueShopping = document.getElementById('cart-continue-shopping');
//   const itemTemplate     = document.getElementById('cart-item-template');
//   const dealTemplate     = document.getElementById('steal-deal-template');

//   if (!drawer || !overlay) {
//     console.warn('[CartDrawer] Required elements not found in DOM. Aborting init.');
//     return;
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      STATE
//   ═══════════════════════════════════════════════════════════════ */
//   let cartData       = null;
//   let isBusy         = false;
//   let dealsFetched   = false;   // fetch once per drawer open, not on every cart update
//   let currentTier    = null;    // currently active discount tier

//   /* ═══════════════════════════════════════════════════════════════
//      UTILITIES
//   ═══════════════════════════════════════════════════════════════ */
//   function formatMoney(cents) {
//     return '₹ ' + Math.round(cents / 100).toLocaleString('en-IN');
//   }

//   /** Shopify CDN image resizer — appends _<size>x to filename */
//   function resizeImage(src, size = '160x200') {
//     if (!src) return '';
//     return src.replace(/(\.[^.?]+)(\?.*)?$/, `_${size}$1$2`);
//   }

//   function showLoader() {
//     let loader = drawer.querySelector('.cart-drawer__loading');
//     if (!loader) {
//       loader = document.createElement('div');
//       loader.className = 'cart-drawer__loading';
//       loader.innerHTML = '<div class="cart-drawer__spinner"></div>';
//       drawer.appendChild(loader);
//     }
//     loader.classList.add('is-visible');
//   }

//   function hideLoader() {
//     const loader = drawer.querySelector('.cart-drawer__loading');
//     if (loader) loader.classList.remove('is-visible');
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      OPEN / CLOSE
//   ═══════════════════════════════════════════════════════════════ */
//   function openDrawer() {
//     dealsFetched = false; // re-fetch deals on each open so list stays fresh
//     drawer.classList.add('is-open');
//     drawer.setAttribute('aria-hidden', 'false');
//     overlay.classList.add('is-active');
//     document.body.style.overflow = 'hidden';
//     fetchCart();
//   }

//   function closeDrawer() {
//     drawer.classList.remove('is-open');
//     drawer.setAttribute('aria-hidden', 'true');
//     overlay.classList.remove('is-active');
//     document.body.style.overflow = '';
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      FETCH CART  — Shopify AJAX API /cart.js
//   ═══════════════════════════════════════════════════════════════ */
//   async function fetchCart() {
//     try {
//       showLoader();
//       const res = await fetch('/cart.js');
//       cartData  = await res.json();
//       renderCart(cartData);
//     } catch (err) {
//       console.error('[CartDrawer] fetchCart:', err);
//     } finally {
//       hideLoader();
//     }
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      RENDER CART ITEMS
//   ═══════════════════════════════════════════════════════════════ */
//   function renderCart(cart) {
//     itemsContainer.innerHTML = '';

//     const hasItems = cart.items && cart.items.length > 0;
//     const totalQty = hasItems ? cart.items.reduce((s, i) => s + i.quantity, 0) : 0;

//     emptyState.style.display  = hasItems ? 'none' : 'flex';
//     footer.style.display      = hasItems ? 'block' : 'none';

//     if (!hasItems) {
//       stealDealsWrap.style.display = 'none';
//       updateTierBanner(0);
//       return;
//     }

//     /* — render each line item — */
//     cart.items.forEach((item, index) => {
//       const node = itemTemplate.content.cloneNode(true);
//       const el   = node.querySelector('.cart-item');

//       el.dataset.lineIndex = index + 1;
//       el.dataset.variantId = item.variant_id;

//       /* image */
//       const img = el.querySelector('.cart-item__image');
//       img.src   = resizeImage(item.image, '160x200');
//       img.alt   = item.title;

//       /* title */
//       el.querySelector('.cart-item__title').textContent = item.product_title || item.title;

//       /* per-unit price */
//       el.querySelector('.cart-item__price').textContent = formatMoney(item.final_price);

//       /* quantity */
//       const qtyEl = el.querySelector('.cart-item__qty-value');
//       qtyEl.textContent = item.quantity;

//       /* — qty controls — */
//       el.querySelector('.cart-item__qty-minus').addEventListener('click', () => {
//         if (isBusy) return;
//         updateItem(index + 1, item.quantity - 1);
//       });
//       el.querySelector('.cart-item__qty-plus').addEventListener('click', () => {
//         if (isBusy) return;
//         updateItem(index + 1, item.quantity + 1);
//       });
//       el.querySelector('.cart-item__remove').addEventListener('click', () => {
//         if (isBusy) return;
//         updateItem(index + 1, 0);
//       });

//       itemsContainer.appendChild(node);
//     });

//     /* subtotal */
//     subtotalEl.textContent = formatMoney(cart.total_price);

//     /* tier banner + steal deals visibility */
//     updateTierBanner(totalQty);

//     /* fetch steal deals once per drawer open */
//     if (STEAL_DEAL_COLLECTION && !dealsFetched) {
//       dealsFetched = true;
//       fetchStealDeals(cart.items.map(i => i.product_id));
//     }
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      TIER BANNER — updates dynamically as qty changes
//   ═══════════════════════════════════════════════════════════════ */
//   function updateTierBanner(totalQty) {
//     /* highlight active tier icon */
//     document.querySelectorAll('.cart-tier__item').forEach(el => el.classList.remove('is-active'));
//     currentTier = TIER_DISCOUNTS.find(t => totalQty >= t.minItems) || null;

//     if (currentTier) {
//       const activeEl = document.querySelector(`.cart-tier__item[data-tier="${currentTier.tier}"]`);
//       if (activeEl) activeEl.classList.add('is-active');
//     }

//     /* banner message — find the NEXT tier the user hasn't unlocked yet */
//     const tiersAsc  = [...TIER_DISCOUNTS].reverse(); // [2-item, 3-item, 4-item]
//     const nextTier  = tiersAsc.find(t => totalQty < t.minItems);
//     const msgEl     = document.getElementById('cart-tier-message');

//     if (msgEl) {
//       if (!nextTier) {
//         /* all tiers unlocked */
//         msgEl.innerHTML = `🎉 You've unlocked the max discount of <strong>${TIER_DISCOUNTS[0].discount}% off!</strong>`;
//       } else {
//         const needed = nextTier.minItems - totalQty;
//         msgEl.innerHTML = `🎁 Add <strong>${needed}</strong> more item${needed > 1 ? 's' : ''} to unlock <strong>${nextTier.discount}% off</strong>`;
//       }
//     }

//     /* steal deals offer bar */
//     if (currentTier) {
//       if (stealOfferText) stealOfferText.textContent = `Offer Unlocked! ${currentTier.label}`;
//       stealDealsWrap.style.display = 'block';
//       if (stealApplyBtn) {
//         stealApplyBtn.style.display  = 'inline-block';
//         // Reset apply button appearance (tier may have changed)
//         stealApplyBtn.textContent      = 'Apply';
//         stealApplyBtn.style.background = '';
//         stealApplyBtn.style.color      = '';
//       }
//     } else {
//       stealDealsWrap.style.display = 'none';
//     }

//     // Keep discount input in sync with current tier automatically
//     autoApplyCurrentTierDiscount();
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      FETCH STEAL DEALS
//      Uses Shopify's /collections/<handle>/products.json
//      Products in that collection drive this section entirely.
//      Pass in cartProductIds to filter out already-in-cart items.
//   ═══════════════════════════════════════════════════════════════ */
//   async function fetchStealDeals(cartProductIds = []) {
//     if (!STEAL_DEAL_COLLECTION) return;
//     stealProducts.innerHTML = '<div class="steal-deals-loading">Loading deals…</div>';

//     try {
//       /* fetch more than needed so we have room to filter */
//       const res  = await fetch(
//         `/collections/${STEAL_DEAL_COLLECTION}/products.json?limit=${STEAL_DEAL_LIMIT + cartProductIds.length}`
//       );

//       if (!res.ok) throw new Error(`Collection "${STEAL_DEAL_COLLECTION}" not found (${res.status})`);

//       const data     = await res.json();
//       const products = (data.products || [])
//         /* filter out products already in cart */
//         .filter(p => !cartProductIds.includes(p.id))
//         .slice(0, STEAL_DEAL_LIMIT);

//       renderStealDeals(products);
//     } catch (err) {
//       console.error('[CartDrawer] fetchStealDeals:', err);
//       stealProducts.innerHTML = '<p class="steal-deals-error">Could not load deals.</p>';
//     }
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      RENDER STEAL DEAL CARDS
//   ═══════════════════════════════════════════════════════════════ */
//   function renderStealDeals(products) {
//     stealProducts.innerHTML = '';

//     if (!products.length) {
//       stealProducts.innerHTML = '<p class="steal-deals-empty">No deals available right now.</p>';
//       return;
//     }

//     products.forEach(product => {
//       /* use first available variant */
//       const variant = product.variants.find(v => v.available) || product.variants[0];
//       if (!variant) return;

//       const node = dealTemplate.content.cloneNode(true);
//       const card = node.querySelector('.steal-deal-card');

//       /* image — use Shopify's CDN resize */
//       const img = card.querySelector('.steal-deal-card__img');
//       img.src   = product.images[0] ? resizeImage(product.images[0].src, '200x250') : '';
//       img.alt   = product.title;

//       /* title */
//       card.querySelector('.steal-deal-card__title').textContent = product.title;

//       /* prices
//          products.json returns prices as strings like "1999.00"
//          multiply by 100 → pass to formatMoney which divides by 100 */
//       const priceCents      = Math.round(parseFloat(variant.price) * 100);
//       const compareAtCents  = variant.compare_at_price
//         ? Math.round(parseFloat(variant.compare_at_price) * 100)
//         : 0;

//       card.querySelector('.steal-deal-card__sale-price').textContent = formatMoney(priceCents);

//       if (compareAtCents && compareAtCents > priceCents) {
//         card.querySelector('.steal-deal-card__original-price').textContent = formatMoney(compareAtCents);
//         const pct = Math.round(((compareAtCents - priceCents) / compareAtCents) * 100);
//         card.querySelector('.steal-deal-card__discount-badge').textContent = `-${pct}%`;
//       } else {
//         const origPriceEl = card.querySelector('.steal-deal-card__original-price');
//         const badgeEl      = card.querySelector('.steal-deal-card__discount-badge');
//         if (origPriceEl) origPriceEl.style.display = 'none';
//         if (badgeEl) badgeEl.style.display = 'none';
//       }

//       /* add-to-cart button on the deal card */
//       const addBtn = card.querySelector('.steal-deal-card__add-btn');
//       addBtn.dataset.variantId = variant.id;
//       addBtn.addEventListener('click', async (e) => {
//         e.stopPropagation();
//         if (isBusy) return;
//         addBtn.disabled = true;
//         addBtn.innerHTML = '<div class="steal-deal-card__spinner"></div>';
//         await addToCart(variant.id, 1);
//         addBtn.disabled = false;
//         addBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//           <circle cx="9" cy="21" r="1" fill="white"/>
//           <circle cx="20" cy="21" r="1" fill="white"/>
//           <path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.61L23 6H6"
//                 stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//         </svg>`;
//       });

//       stealProducts.appendChild(node);
//     });
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      UPDATE CART LINE  — /cart/change.js
//   ═══════════════════════════════════════════════════════════════ */
//   async function updateItem(line, quantity) {
//     isBusy = true;
//     showLoader();
//     try {
//       const res = await fetch('/cart/change.js', {
//         method : 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body   : JSON.stringify({ line, quantity }),
//       });
//       cartData = await res.json();
//       renderCart(cartData);
//       updateCartIconCount(cartData.item_count);
//     } catch (err) {
//       console.error('[CartDrawer] updateItem:', err);
//     } finally {
//       isBusy = false;
//       hideLoader();
//     }
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      ADD TO CART  — /cart/add.js
//   ═══════════════════════════════════════════════════════════════ */
//   async function addToCart(variantId, quantity = 1) {
//     isBusy = true;
//     showLoader();
//     try {
//       const res = await fetch('/cart/add.js', {
//         method : 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body   : JSON.stringify({ id: variantId, quantity }),
//       });
//       if (!res.ok) {
//         const err = await res.json();
//         throw new Error(err.description || 'Add to cart failed');
//       }
//       dealsFetched = false; // refresh deals list (newly added item should be excluded)
//       await fetchCart();
//       updateCartIconCount(cartData?.item_count || 0);
//       if (!drawer.classList.contains('is-open')) openDrawer();
//     } catch (err) {
//       console.error('[CartDrawer] addToCart:', err);
//       alert(err.message || 'Could not add item to cart.');
//     } finally {
//       isBusy = false;
//       hideLoader();
//     }
//   }

//   async function addItemsToCart(items = []) {
//     if (!items.length || isBusy) return;

//     isBusy = true;
//     showLoader();

//     try {
//       const res = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ items })
//       });

//       if (!res.ok) {
//         const err = await res.json();
//         throw new Error(err.description || 'Add to cart failed');
//       }

//       dealsFetched = false;
//       await fetchCart();
//       updateCartIconCount(cartData?.item_count || 0);
//       openDrawer();

//     } catch (err) {
//       console.error('[CartDrawer] addItemsToCart:', err);
//       alert(err.message || 'Could not add items to cart.');
//     } finally {
//       isBusy = false;
//       hideLoader();
//     }
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      APPLY DISCOUNT
//      Injects a hidden "discount" input into the checkout form so the
//      code is submitted with the POST to /checkout.
//      Make sure these codes exist in Shopify Admin → Discounts.
//   ═══════════════════════════════════════════════════════════════ */
//   function applyDiscountToForm(code) {
//     const form = document.getElementById('cart-drawer-checkout-form');
//     if (!form) return;
//     // Remove any previously injected discount input
//     const existing = form.querySelector('input[name="discount"]');
//     if (existing) existing.remove();

//     if (code) {
//       const input = document.createElement('input');
//       input.type  = 'hidden';
//       input.name  = 'discount';
//       input.value = code;
//       form.appendChild(input);

//       // Visual feedback on the apply button
//       if (stealApplyBtn) {
//         stealApplyBtn.textContent      = '✓ Applied';
//         stealApplyBtn.style.background = '#2d8a4e';
//         stealApplyBtn.style.color      = '#fff';
//       }
//     }
//   }

//   if (stealApplyBtn) {
//     stealApplyBtn.addEventListener('click', (e) => {
//       e.stopPropagation();
//       if (!currentTier) return;
//       applyDiscountToForm(currentTier.code);
//     });
//   }

//   // Auto-apply discount whenever tier changes so it's always up to date
//   // when merchant clicks Place Order without clicking Apply manually
//   function autoApplyCurrentTierDiscount() {
//     if (currentTier) {
//       applyDiscountToForm(currentTier.code);
//     } else {
//       // Remove discount if no tier active
//       const form = document.getElementById('cart-drawer-checkout-form');
//       const existing = form && form.querySelector('input[name="discount"]');
//       if (existing) existing.remove();
//     }
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      CART ICON COUNT — update header bubble
//   ═══════════════════════════════════════════════════════════════ */
//   function updateCartIconCount(count) {
//     [
//       '.cart-count',
//       '.header__cart-count',
//       '[data-cart-count]',
//       '#cart-count',
//       '.cart-item-count',
//       '.cart-link__bubble-num',
//     ].forEach(sel => {
//       document.querySelectorAll(sel).forEach(el => {
//         el.textContent    = count;
//         el.style.display  = count > 0 ? '' : 'none';
//       });
//     });
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      BIND ADD-TO-CART FORMS (product cards)
//   ═══════════════════════════════════════════════════════════════ */
//   function bindAddToCartForms() {
//     /* form submit */
//     document.addEventListener('submit', async (e) => {
//       const form = e.target.closest('[data-type="add-to-cart-form"]');
//       if (!form) return;
//       e.preventDefault();
//       if (isBusy) return;
//       const variantId = parseInt(form.querySelector('input[name="id"]')?.value, 10);
//       const quantity  = parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1;
//       if (variantId) await addToCart(variantId, quantity);
//     });

//     /* button click (some themes submit via click not submit event) */
//     document.addEventListener('click', async (e) => {
//       const btn = e.target.closest('button[name="add"].card-add-to-cart-btn');
//       if (!btn) return;
//       const form = btn.closest('[data-type="add-to-cart-form"]');
//       if (!form) return;
//       e.preventDefault();
//       if (isBusy) return;
//       const variantId = parseInt(form.querySelector('input[name="id"]')?.value, 10);
//       const quantity  = parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1;
//       if (variantId) await addToCart(variantId, quantity);
//     });
//   }

//   /* ═══════════════════════════════════════════════════════════════
//      EVENT LISTENERS
//   ═══════════════════════════════════════════════════════════════ */
//   if (closeBtn) {
//     closeBtn.addEventListener('click', (e) => {
//       e.stopPropagation();
//       closeDrawer();
//     });
//   }

//   overlay.addEventListener('click', (e) => {
//     e.stopPropagation();
//     closeDrawer();
//   });

//   if (continueShopping) {
//     continueShopping.addEventListener('click', (e) => {
//       e.stopPropagation();
//       closeDrawer();
//     });
//   }

//   document.addEventListener('keydown', e => {
//     if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
//   });

//   /* ─────────────────────────────────────────────────────────────
//      OPEN DRAWER TRIGGER
//      Scoped strictly to elements with [data-cart-toggle] so this
//      never accidentally matches nav menu links, mega menu items,
//      or other unrelated anchors that might resolve to /cart.

//      Make sure your header cart link has this attribute, e.g.:
//        <a href="{{ routes.cart_url }}" class="icon-box cart-box" data-cart-toggle>
//   ───────────────────────────────────────────────────────────── */
//   document.addEventListener('click', e => {
//     const trigger = e.target.closest('[data-cart-toggle]');
//     if (!trigger) return;
//     e.preventDefault();
//     e.stopPropagation();
//     openDrawer();
//   });

//   /* ═══════════════════════════════════════════════════════════════
//      INIT
//   ═══════════════════════════════════════════════════════════════ */
//   bindAddToCartForms();

//   /* global API for other scripts */
//   window.CartDrawer = { open: openDrawer, close: closeDrawer, addToCart, addItemsToCart, fetchCart };

// })();

class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-drawer-overlay');
    this.config = window.__cartDrawerConfig || { tierDiscounts: [], stealDealHandle: '' };
    
    this.initElements();
    this.initEvents();
    this.fetchCart();
  }

  initElements() {
    this.itemsContainer = document.getElementById('cart-drawer-items');
    this.emptyContainer = document.getElementById('cart-drawer-empty');
    this.footerContainer = document.getElementById('cart-drawer-footer');
    this.subtotalEl = document.getElementById('cart-subtotal-value');
    this.totalEl = document.getElementById('cart-total-value');
    this.discountRow = document.getElementById('cart-discount-row');
    this.discountLabel = document.getElementById('cart-discount-label');
    this.discountValueEl = document.getElementById('cart-discount-value');
    this.itemCountBadge = document.getElementById('cart-item-count-badge');
    
    this.savingsStatusText = document.getElementById('cart-savings-status-text');
    this.savingsMainText = document.getElementById('cart-savings-main-text');
    this.totalSavedDisplay = document.getElementById('cart-total-saved-display');
    
    this.footerOfferText = document.getElementById('cart-footer-offer-text');
    
    this.stealDealsWrapper = document.getElementById('cart-steal-deals');
    this.stealProductsContainer = document.getElementById('cart-steal-products');
    this.stealApplyBtn = document.getElementById('cart-steal-apply-btn');
    this.stealOfferText = document.getElementById('cart-steal-offer-text');
  }

  initEvents() {
    document.getElementById('cart-drawer-close').addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    
    const continueBtn = document.getElementById('cart-continue-shopping');
    if (continueBtn) {
      continueBtn.addEventListener('click', () => this.close());
    }

    document.querySelectorAll('[data-cart-drawer-trigger], a[href="/cart"]').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    this.itemsContainer.addEventListener('click', (e) => {
      const minusBtn = e.target.closest('.cart-item__qty-minus');
      const plusBtn = e.target.closest('.cart-item__qty-plus');
      const removeBtn = e.target.closest('.cart-item__remove');

      const itemEl = e.target.closest('.cart-item');
      if (!itemEl) return;
      const lineIndex = parseInt(itemEl.dataset.lineIndex, 10);
      const currentQty = parseInt(itemEl.dataset.quantity, 10);

      if (minusBtn) {
        this.updateItemQuantity(lineIndex, currentQty - 1);
      } else if (plusBtn) {
        this.updateItemQuantity(lineIndex, currentQty + 1);
      } else if (removeBtn) {
        this.updateItemQuantity(lineIndex, 0);
      }
    });

    if (this.stealProductsContainer) {
      this.stealProductsContainer.addEventListener('click', (e) => {
        const addBtn = e.target.closest('.steal-deal-card__add-btn');
        if (!addBtn) return;
        const variantId = addBtn.dataset.variantId;
        if (variantId) {
          this.addToCart(variantId, 1);
        }
      });
    }

    // Custom toggle event listener for immediate sync
    document.documentElement.addEventListener('cart:toggle', () => {
      this.open();
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.fetchCart();
  }

  close() {
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  async fetchCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.renderCart(cart);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  async updateItemQuantity(lineIndex, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: quantity })
      });
      const cart = await response.json();
      this.renderCart(cart);
    } catch (error) {
      console.error('Error updating cart item:', error);
    }
  }

  async addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      const cart = await response.json();
      this.renderCart(cart);
      this.open();
    } catch (error) {
      console.error('Error adding item to cart:', error);
    }
  }

  formatMoney(cents) {
    return '₹ ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  renderCart(cart) {
    if (!cart) return;

    if (this.itemCountBadge) {
      this.itemCountBadge.textContent = `(${cart.item_count})`;
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

    if (!cart.items || cart.items.length === 0) {
      this.itemsContainer.innerHTML = '';
      this.emptyContainer.style.display = 'block';
      this.footerContainer.style.display = 'none';
      if (this.stealDealsWrapper) this.stealDealsWrapper.style.display = 'none';
      return;
    }

    this.emptyContainer.style.display = 'none';
    this.footerContainer.style.display = 'block';

    this.itemsContainer.innerHTML = '';
    const template = document.getElementById('cart-item-template');

    cart.items.forEach((item, index) => {
      const clone = template.content.cloneNode(true);
      const itemEl = clone.querySelector('.cart-item');
      
      itemEl.dataset.lineIndex = index + 1;
      itemEl.dataset.quantity = item.quantity;
      
      clone.querySelector('.cart-item__image').src = item.image ? item.image : '';
      clone.querySelector('.cart-item__image').alt = item.title;
      clone.querySelector('.cart-item__title').textContent = item.product_title;
      
      const optionsEl = clone.querySelector('.cart-item__options');
      let variantTextParts = [];
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantTextParts.push(item.variant_title);
      }
      variantTextParts.push(`Qty: ${item.quantity}`);
      optionsEl.textContent = variantTextParts.join('  •  ');

      clone.querySelector('.cart-item__price').textContent = this.formatMoney(item.final_price);
      
      const comparePriceEl = clone.querySelector('.cart-item__compare-price');
      const badgeEl = clone.querySelector('.cart-item__badge');
      
      if (item.original_price > item.final_price) {
        comparePriceEl.textContent = this.formatMoney(item.original_price);
        const savingPercent = Math.round(((item.original_price - item.final_price) / item.original_price) * 100);
        badgeEl.textContent = `${savingPercent}% OFF`;
        badgeEl.style.display = 'inline-block';
      } else {
        comparePriceEl.style.display = 'none';
        badgeEl.style.display = 'none';
      }

      clone.querySelector('.cart-item__qty-value').textContent = item.quantity;
      this.itemsContainer.appendChild(clone);
    });

    const totalItems = cart.items.reduce((sum, item) => sum + item.quantity, 0);
    const subtotal = cart.items_subtotal_price;
    
    const sortedTiers = [...this.config.tierDiscounts].sort((a, b) => b.minItems - a.minItems);
    let activeTier = null;
    let nextTier = null;

    for (let i = 0; i < sortedTiers.length; i++) {
      if (totalItems >= sortedTiers[i].minItems) {
        activeTier = sortedTiers[i];
        break;
      }
    }

    for (let i = sortedTiers.length - 1; i >= 0; i--) {
      if (totalItems < sortedTiers[i].minItems) {
        nextTier = sortedTiers[i];
        break;
      }
    }

    if (activeTier) {
      if (this.savingsStatusText) this.savingsStatusText.textContent = `Congrats! You've unlocked`;
      if (this.savingsMainText) this.savingsMainText.textContent = `${activeTier.discount}% OFF on your order`;
      if (this.footerOfferText) this.footerOfferText.textContent = `Offer Unlocked: Flat ${activeTier.discount}% Off`;
    } else if (nextTier) {
      const diff = nextTier.minItems - totalItems;
      if (this.savingsStatusText) this.savingsStatusText.textContent = `Add ${diff} more item${diff > 1 ? 's' : ''} to unlock`;
      if (this.savingsMainText) this.savingsMainText.textContent = `${nextTier.discount}% OFF Tier`;
      if (this.footerOfferText) this.footerOfferText.textContent = `Unlock ${nextTier.discount}% Off with ${nextTier.minItems} items`;
    } else {
      if (this.savingsStatusText) this.savingsStatusText.textContent = `Add items to unlock discounts`;
      if (this.savingsMainText) this.savingsMainText.textContent = `Unlock up to 15% OFF`;
      if (this.footerOfferText) this.footerOfferText.textContent = `Offer Unlocked: Flat Off`;
    }

    let discountAmount = 0;
    if (activeTier) {
      discountAmount = Math.round(subtotal * (activeTier.discount / 100));
    }

    let itemCompareSavings = cart.items.reduce((sum, item) => {
      if (item.original_price > item.final_price) {
        return sum + ((item.original_price - item.final_price) * item.quantity);
      }
      return sum;
    }, 0);

    const totalCalculatedSavings = itemCompareSavings + discountAmount;
    if (this.totalSavedDisplay) this.totalSavedDisplay.textContent = this.formatMoney(totalCalculatedSavings);

    if (this.subtotalEl) this.subtotalEl.textContent = this.formatMoney(subtotal);

    if (discountAmount > 0 && activeTier) {
      if (this.discountRow) this.discountRow.style.display = 'flex';
      if (this.discountLabel) this.discountLabel.textContent = `Discount (${activeTier.discount}%)`;
      if (this.discountValueEl) this.discountValueEl.textContent = `- ${this.formatMoney(discountAmount)}`;
    } else {
      if (this.discountRow) this.discountRow.style.display = 'none';
    }

    const finalTotalPrice = subtotal - discountAmount;
    if (this.totalEl) this.totalEl.textContent = this.formatMoney(finalTotalPrice);

    if (this.config.stealDealHandle && this.config.stealDealHandle.trim() !== '') {
      this.fetchStealDeals(this.config.stealDealHandle);
    }
  }

  async fetchStealDeals(collectionHandle) {
    if (!this.stealDealsWrapper) return;
    try {
      const response = await fetch(`/collections/${collectionHandle}/products.json`);
      if (!response.ok) {
        this.stealDealsWrapper.style.display = 'none';
        return;
      }
      const data = await response.json();
      const products = data.products || [];

      if (products.length > 0) {
        this.stealDealsWrapper.style.display = 'block';
        this.renderStealDeals(products);
      } else {
        this.stealDealsWrapper.style.display = 'none';
      }
    } catch (err) {
      console.error('Error fetching steal deals:', err);
      this.stealDealsWrapper.style.display = 'none';
    }
  }

  renderStealDeals(products) {
    if (!this.stealProductsContainer) return;
    this.stealProductsContainer.innerHTML = '';
    const template = document.getElementById('steal-deal-template');
    if (!template) return;

    products.slice(0, 2).forEach(product => {
      const variant = product.variants[0];
      if (!variant) return;

      const clone = template.content.cloneNode(true);
      const img = clone.querySelector('.steal-deal-card__img');
      img.src = product.images && product.images.length > 0 ? product.images[0].src : '';
      img.alt = product.title;

      clone.querySelector('.steal-deal-card__title').textContent = product.title;
      
      const priceCents = variant.price * 100;
      const compareCents = variant.compare_at_price ? variant.compare_at_price * 100 : 0;

      clone.querySelector('.steal-deal-card__sale-price').textContent = this.formatMoney(priceCents);
      
      const origPriceEl = clone.querySelector('.steal-deal-card__original-price');
      const badgeEl = clone.querySelector('.steal-deal-card__discount-badge');

      if (compareCents > priceCents) {
        origPriceEl.textContent = this.formatMoney(compareCents);
        const savingPct = Math.round(((compareCents - priceCents) / compareCents) * 100);
        badgeEl.textContent = `${savingPct}% OFF`;
      } else {
        origPriceEl.style.display = 'none';
        badgeEl.style.display = 'none';
      }

      const addBtn = clone.querySelector('.steal-deal-card__add-btn');
      addBtn.dataset.variantId = variant.id;

      this.stealProductsContainer.appendChild(clone);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawer();
});